export const positionList = [
    {
        "title": "International Affairs Commentator",
        "items": [
            {
                "itemTitle": "",
                "itemContent": [
                  "International Relations","Global Affairs","News Editing","Media Communication",
                  "Multilingual Skills","Cross-border Work Experience",
                ]
            },
            
        ]
    },
    {
        "title": "Investment Risk Analyst",
        "items": [
            {
                "itemTitle": "",
                "itemContent": [
                  "Investment Analysis","Risk Research and Strategy","International Markets",
                  "Geopolitical Risk","Compliance Management","Portfolio Management","Multilingual Skills","Cross-border Work Experience",
                ]
            },
           
        ]
    },
    {
        "title": "Geopolitical Analyst",
        "items": [
            {
                "itemTitle": "",
                "itemContent": [
                    "Geopolitical Analysis","International Relations","Policy Analysis","International Security",
                    "Strategic Research", "Conflict Analysis",  "Global Affairs"  ,"Report Writing",
                ]
            },
            
        ]
    }
];
